import { render, staticRenderFns } from "./BafiFileAttacher.vue?vue&type=template&id=6f91f498&scoped=true&"
import script from "./BafiFileAttacher.vue?vue&type=script&lang=js&"
export * from "./BafiFileAttacher.vue?vue&type=script&lang=js&"
import style0 from "./BafiFileAttacher.vue?vue&type=style&index=0&id=6f91f498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f91f498",
  null
  
)

export default component.exports